'use client';

import { useState } from 'react';
import LoginForm from './LoginForm';
import SecurityBadges from './SecurityBadges';
import SupportSection from './SupportSection';

const LoginInteractive = () => {
  const [loginSuccess, setLoginSuccess] = useState(false);

  const handleLoginSuccess = (userType: 'patient' | 'admin') => {
    setLoginSuccess(true);
  };

  return (
    <div className="min-h-screen bg-background">
      <div className="container mx-auto px-4 py-12">
        <div className="max-w-6xl mx-auto space-y-12">
          <div className="text-center mb-8">
            <div className="inline-flex items-center gap-3 mb-4">
              <div className="w-12 h-12 bg-primary rounded-lg flex items-center justify-center">
                <svg className="w-7 h-7 text-primary-foreground" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M12 21.35l-1.45-1.32C5.4 15.36 2 12.28 2 8.5 2 5.42 4.42 3 7.5 3c1.74 0 3.41.81 4.5 2.09C13.09 3.81 14.76 3 16.5 3 19.58 3 22 5.42 22 8.5c0 3.78-3.4 6.86-8.55 11.54L12 21.35z"/>
                </svg>
              </div>
              <h1 className="text-2xl font-heading font-semibold text-foreground">
                HealConnect
              </h1>
            </div>
            <p className="text-muted-foreground max-w-2xl mx-auto">
              Secure access to your personalized healthcare dashboard. Your health information is protected with industry-leading security standards.
            </p>
          </div>

          <LoginForm onSuccess={handleLoginSuccess} />

          <SecurityBadges />

          <SupportSection />

          <div className="text-center text-sm text-muted-foreground">
            <p>
              By signing in, you agree to our Terms of Service and Privacy Policy.
              <br />
              All communications are encrypted and HIPAA compliant.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LoginInteractive;